export { default } from './searchTitle';